/* eslint-disable no-unused-vars */
/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  getList({ commit }, student_id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`course-students/${student_id}/auto-schedules`)
        .then((response) => {
          commit("SET_LIST", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  create({ commit }, { student_id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`course-students/${student_id}/auto-schedules`, payload)
        .then((response) => {
          commit("ADD", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  update({ commit }, { student_id, id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`course-students/${student_id}/auto-schedules/${id}`, payload)
        .then((response) => {
          commit("UPDATE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  delete({ commit }, { student_id, id }) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`course-students/${student_id}/auto-schedules/${id}`)
        .then((response) => {
          commit("REMOVE", id);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  resetList({ commit }) {
    commit("SET_LIST", []);
  },
};
